import { render, staticRenderFns } from "./relatedContacts.vue?vue&type=template&id=498ac688&"
import script from "./relatedContacts.vue?vue&type=script&lang=js&"
export * from "./relatedContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports